import React, { FC } from 'react';
import translate from '@translate';
import { useNavigate, useLocation } from 'react-router-dom';
import BodyTopBlock from 'src/components/BodyTopBlock';
import { AddIcon, InventoryIcon, ReloadIcon } from 'src/components/SkladonIcon/Icons';
import { EditIcon, HideIcon, ImportIcon, ShowIcon } from 'src/components/SkladonIcon/SmallIcons';
import { ExportTypeType, SelectRowType } from 'src/types/table';
import { checkPermission } from 'src/utils/checkPermission';
import { TABS } from './constants';
import StoreIcon from '@mui/icons-material/Store';
import ReadMoreIcon from '@mui/icons-material/ReadMore';
// import InventoryIcon from '@mui/icons-material/Inventory';
import ExportTableAction from 'src/components/ExportTableAction';
import { ProductType } from '../../types/product';

export const getTabs = () => {
    const ableProductSets = checkPermission('PRODUCT_SET.LIST');
    const ableBillsOfMaterials = checkPermission('BILL_OF_MATERIALS.LIST');
    return TABS.filter((item) => {
        if (!ableProductSets && item.value === 'sets') {
            return false;
        }
        if (!ableBillsOfMaterials && item.value === 'bill_of_materials') {
            return false;
        }
        return true;
    });
};

type TopBlockProps = {
    reloadProductsList: () => void;
    permissionCreate: boolean;
    permissionUpdate: boolean;
    permissionAllProviders: boolean;
    permissionDcixImportProducts: boolean;
    permissionDcixImportEans: boolean;
    selectedRows: SelectRowType[];
    filter: string;
    handleActivateProducts: () => void;
    handleDeactivateProducts: () => void;
    handleExport: (type: ExportTypeType) => void;
    toggleAllStock: () => void;
    handleSyncProductsToDcixFetch: () => void;
    handleMassUpdate: () => void;
    handleSyncEansToDcixFetch: () => void;
    allStock: boolean;
    productsData: ProductType[]
};
const TopBlock: FC<TopBlockProps> = (props) => {
    const navigate = useNavigate();
    const location = useLocation();
    const handleNotWithStock = () => {
        navigate(`/products/${selected}`);
    };


    const handleChange = (newUrl: string) => {
        navigate('/products/' + newUrl);
    };

    const handleNew = () => {
        navigate(`/products/new`);
    };

    const handleImport = () => {
        navigate(`/products/import`);
    };

    const handleAllProviders = () => {
        navigate(`/products/${selected}/all`);
    };

    const selected = location.pathname.split('/')[2];
    return (
        <BodyTopBlock
            tabs={getTabs()}
            selectTab={selected}
            onChangeTab={handleChange}
            actions={[
                {
                    onClick: handleNotWithStock,
                    icon: <InventoryIcon />,
                    tooltip: translate('products.action.withStock'),
                    variant: 'outlined',
                    active: true,
                },
                {
                    onClick: props.toggleAllStock,
                    icon: <ReadMoreIcon />,
                    tooltip: translate('products.action.allStock'),
                    variant: 'outlined',
                    active: props.allStock,
                },
                {
                    // onClick: () => props.setAllProviders(!props.allProviders),
                    onClick: handleAllProviders,
                    icon: <StoreIcon />,
                    tooltip: translate('products.action.allProviders'),
                    variant: 'outlined',
                    // active: props.allProviders,
                    active: false,
                    hidden: !props.permissionAllProviders,
                },
                {
                    onClick: props.reloadProductsList,
                    icon: <ReloadIcon />,
                    tooltip: translate('products.action.synchronizeTable'),
                    variant: 'outlined',
                },
                {
                    items: [
                        {
                            onClick: handleImport,
                            icon: <ImportIcon />,
                            label: translate('products.action.importProducts'),
                            variant: 'text',
                            hidden: !props.permissionCreate || !props.permissionUpdate,
                        },
                        {
                            node: (
                                <ExportTableAction
                                    title={translate('products.action.dowloadProductsTable')}
                                    handleExport={props.handleExport}
                                    textWithIcon
                                />
                            ),
                        },
                        {
                            label: translate('products.action.activateProducts'),
                            onClick: props.handleActivateProducts,
                            icon: <ShowIcon />,
                            hidden:
                                props.filter !== 'inactive' || !props.permissionUpdate || !props.selectedRows.length,
                            variant: 'text',
                        },
                        {
                            label: translate('products.action.deactivateProducts'),
                            onClick: props.handleDeactivateProducts,
                            icon: <HideIcon />,
                            hidden: props.filter !== 'active' || !props.permissionUpdate || !props.selectedRows.length,
                            variant: 'text',
                        },
                        {
                            label: translate('products.action.syncProductsToDcix'),
                            onClick: props.handleSyncProductsToDcixFetch,
                            icon: <ReloadIcon />,
                            hidden: !props.permissionDcixImportProducts,
                            variant: 'text',
                        },
                        {
                            label: translate('products.action.syncEansToDcix'),
                            onClick: props.handleSyncEansToDcixFetch,
                            icon: <ReloadIcon />,
                            hidden: !props.permissionDcixImportEans,
                            variant: 'text',
                        },
                        {
                            onClick: props.handleMassUpdate,
                            icon: <EditIcon />,
                            label: translate('products.action.massUpdate'),
                            variant: 'text',
                            hidden: !props.permissionUpdate || props.selectedRows.some(rowId => {
                                const product = props.productsData.find(product => product.ID === Number(rowId));
                                return product && product.PRODUCT_TYPE === 'pack';
                            }),
                        },
                    ],
                },
                {
                    label: translate('products.createNew'),
                    onClick: handleNew,
                    icon: <AddIcon />,
                    hidden: !props.permissionCreate,
                },
            ]}
        />
    );
};

export default TopBlock;
